import { render, staticRenderFns } from "./eventosbypunto.vue?vue&type=template&id=71580c22"
import script from "./eventosbypunto.vue?vue&type=script&lang=js"
export * from "./eventosbypunto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports